<template>

<div class="container">
    <h1><b-icon icon="file-earmark-check"></b-icon> Transcript


<div class="float-right" style="margin-top: -62px;">


  <b-button v-b-modal.modal-help v-b-tooltip.hover title="Help" class="help"> <b-icon icon="question-square-fill" ></b-icon> Help</b-button>
<help id="14" />


</div>


    </h1>
    <!-- <div class="text-center">
                  <b-spinner variant="primary" label="Text Centered"></b-spinner>
                </div> -->
<div class="row">
<div class="col-md-12">
<div class="panal mt-20">
<div class="panal-header">Student Data</div> 
<div class="panal-body">
  <div class="row">
    <div class="col-md-12">
 <div class="row" v-if="Transcript && personalData && TranscriptDetails">
              <div class="col-md-3 col-sm-12 ">
                <div class="profileData">Student Name </div>
              </div>
               <div class="col-md-3 col-sm-12 ">
                 <div class="profileData2"> {{personalData[0].FirstNameEN+' '+personalData[0].SecondNameEN+' '+personalData[0].ThirdNameEN}}</div>
                 </div>
              
              <div class="col-md-3 col-sm-12">
                <div class="profileData">Year/Term</div> 
                </div>
               <div class="col-md-3 col-sm-12 ">
               <div class="profileData2">{{Transcript[0].Name}}</div>
              </div>
              <div class="col-md-3 col-sm-12">
                <div class="profileData">CGPA </div> 
                </div>
               <div class="col-md-3 col-sm-12 ">
                <div class="profileData2">{{TranscriptDetails[0].CGPA}}</div>
              </div>
              <div class="col-md-3 col-sm-12">
                <div class="profileData">Faculty Name </div> 
                </div>
               <div class="col-md-3 col-sm-12 ">
               <div class="profileData2">{{personalData[0].FacultyName_EN}}</div>
              </div>
           
       </div>     
 </div>
   
    <!-- <div class="col-md-2">
      <div class="app-stu-photo"><img src="../../assets/SU_Logo.png" /></div>
      </div> -->
      
 
 </div>
</div>
 
            


<div class="clearfix"></div>

</div>
</div>
</div>


    <div class="bg-filter" style="width:99%">
   <div class="row ">     
    <div class="col-md-6">

   <b-form-select v-model="selected" @change="SemesterYearById()" v-b-tooltip.hover title="Choose Year">
     
      <option selected value=null>Choose Year </option>
      <option v-for="semester in academicYear" :value="semester.serial" v-bind:key="semester.serial" >{{semester.Name}}</option>
   </b-form-select>
   

    </div>

    <div class="col-md-6">

   <b-form-select v-model="selected2" @change="GetStudentTranscript" v-b-tooltip.hover title="Choose Semester">
     <option selected value=null>Choose Semester</option>
      <option v-for="year in SemesterYeaByYearId" :value="year.SemesterYearserial" v-bind:key="year.SemesterYearserial" >{{year.SemesterNameEN}}</option>
   </b-form-select>
  

    </div>
    
    </div>
    </div>
<div class="row">
<div class="col-md-12">
<div class="panal mt-20">
<div class="panal-header">Student Transcript</div> 
<div class="panal-body">


    <div class="table-responsive">
               <table class="table mt-3 table-bordered">
                <thead class="thead-light">
                  <tr>
                    <th scope="col">Course Code</th>
                    <th scope="col">CourseName EN</th>
                    <th scope="col">GradeName</th>
                     <th scope="col">CreditHours</th>
                     <th scope="col">Quality Points</th>

                  </tr>
                </thead>
                <tbody>
             
  <tr v-if="empty"><td colspan="7"> No Data </td></tr>
                 <tr v-else v-for="item in Transcript" v-bind:Key="item.StudentID">
                   
                    <td>{{item.CourseCode}} </td>
                    <td>{{item.CourseNameEN}}</td>
                    <td >{{item.GradeName}}  </td>
                    <td >{{item.CreditHours}} </td>
                    <td >{{item.QualityPoints}} </td>
                  </tr>
                


<!--
                  <tr>
                   
                    <td>{{Transcript[0].CourseCode}} </td>
                    <td>{{Transcript[0].CourseNameEN}}</td>
                    <td >{{Transcript[0].GradeName}}</td>
                    <td >{{Transcript[0].CreditHours}}</td>
                    <td >{{Transcript[0].QualityPoints}}</td>
                  </tr>
                  -->
                  <tr>
                      <td colspan="5" style="padding:0px !important">

      <table v-if="TranscriptDetails" class="table mt-3 table-bordered text-center" style="padding:0px !important;background-color: #e9ecef;">
                <thead class="thead-light ">
                  <tr>
                    <th  style="background: #285475;padding:.25rem !important"></th>
                    <th style="padding:.25rem !important">CreditHours</th>
                    <th style="padding:.25rem !important">Earned</th>
                     <th style="padding:.25rem !important">QPoints</th>
                    

                  </tr>
                </thead>
                <tbody>
                  <tr style="padding:.25rem !important">
                   
                    <th style="background: #285475; color:#fff;padding:.25rem !important">Term</th>
                    <td>{{TranscriptDetails[0].CreditHours}}</td>
                    <td >{{TranscriptDetails[0].EarnedCredits}}</td>
                    <td >{{TranscriptDetails[0].QualityPoints}}</td>
                  
                  </tr>
                 <tr>
                   
                    <th style="background: #285475;color:#fff;padding:.25rem !important">Cum</th>
                    <td>{{TranscriptDetails[0].CreditHours}}</td>
                    <td >{{TranscriptDetails[0].CumEarnedCredits}}</td>
                    <td >{{TranscriptDetails[0].CumQualityPoints}}</td>
                  
                  </tr>

                </tbody>
              </table>






                      </td>
                  </tr>

                </tbody>
              </table>
              <div class="row" >
    <div v-if="message" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">{{message}}</div>

</div>
</div>

</div>
</div>
</div>
</div>





</div>
</template>
<script>
import studentData from '../../services/student/studentDataServices';
import TranscriptServicesData from '../../services/academic/TranscriptServices';
//import ApplicantService from '../../services/Applicant/Applicant.service';
import Help from '../Help.vue';

    export default {
  components: { Help },
        name: 'transcript',
          data() {
      return {
      
        selected: null,
        selected2: null ,
        personalData: [], 
        Transcript: [],
        academicYear: [],  
        SemesterYearId: null,
        SemesterYeaByYearId: null,
        TranscriptDetails: '',
       empty:false,
       message:'',
     enrollmentid :  0 ,
     transferid : 0,
     successful:'',
     info:"",
    
     
      }
    },
    computed:{
           currenUser(){
            return  this.$store.state.auth.user
          }
       },


        mounted(){

    //        let id = 14;

    // ApplicantService.GetHelpPages(id).then(response => {
    //     this.info = response.data
    //   });
     // this.currenUser.StudentID
            studentData.GetPersonalData(this.currenUser.StudentID).then(Response =>{
              // this.isLoading = false ;
               this.personalData = Response.data
                // eslint-disable-next-line no-console
                  // console.log('personalData ', Response.data)
           }, error => {
              
                  // eslint-disable-next-line no-console
                  // console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }),

            // this.currenUser.StudentID
            TranscriptServicesData.SelectAcademicYearByStudent(this.currenUser.StudentID).then(Response =>{
              // this.isLoading = false ;
               this.academicYear = Response.data;
               //this.SemesterYearId = Response.data[0].serial;
                // eslint-disable-next-line no-console
                  // console.log('academicYear ', Response.data)
           }, error => {
              
                  // eslint-disable-next-line no-console
                  // console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }),

                  // remove the 1 and add the semserterid 
                  // Zero refare to the current semester 

            studentData.SelectStudentTranscriptBySemester(this.currenUser.StudentID,0).then(Response =>{
              // this.isLoading = false ;
               this.Transcript = Response.data
               this.enrollmentid = this.Transcript[0].EnrollmentStudentID
               this.transferid = this.Transcript[0].StudentTransferID
               // this.empty =false
                // eslint-disable-next-line no-console
                  // console.log('Transcript ', Response.data)
           },
         error => {
              
                  // eslint-disable-next-line no-console
                  // console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }).then(x => {
               x
                  studentData.SelectSTudentSemesterSummery(this.enrollmentid,this.transferid).then(Response =>{
              // this.isLoading = false ;
               this.TranscriptDetails = Response.data;              
               // this.empty =false
                // eslint-disable-next-line no-console
                  // console.log('TranscriptDetails ', Response.data)
           },
         error => {
              
                  // eslint-disable-next-line no-console
                  // console.log(error.response.status)
              
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            })
            }) 
       
       
         
       
       
       }, 
       methods:{
            SemesterYearById(){
         
          TranscriptServicesData.GetSemesterYeaByYearId(this.selected).then(Response =>{
          this.SemesterYeaByYearId=Response.data;

           // eslint-disable-next-line no-console
              // console.log('SemesterYeaByYearId ', Response.data)
        }, error => {
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
            })
          
          },
          GetStudentTranscript(){
          
            studentData.SelectStudentTranscriptBySemester(this.currenUser.StudentID,this.selected2).then(Response =>{
              // this.isLoading = false ;
               this.empty=false
               this.Transcript = Response.data
               this.enrollmentid = this.Transcript[0].EnrollmentStudentID
               this.transferid = this.Transcript[0].StudentTransferID
               // this.empty =false
                // eslint-disable-next-line no-console
                  // console.log('Transcript ', Response.data)
           }).then(x => {
                // eslint-disable-next-line no-console
                  console.log('x',x)
                  studentData.SelectSTudentSemesterSummery(this.enrollmentid,this.transferid).then(Response =>{
              // this.isLoading = false ;
               this.TranscriptDetails = Response.data;              
               // this.empty =false
                // eslint-disable-next-line no-console
                 // console.log('TranscriptDetails ', Response.data)
               })
            }).catch(error=> {
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                   this.successful = false
                   this.empty=true
                if(error.response.status == 404) this.message =''
              // eslint-disable-next-line no-console
                  // console.log(error)
            }) 
          }
       }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >

.help {
    color: #fff;
    background-color: #ff8600;
    /* padding: 2px 16px; */
}
h1{
    color: #285475;
    font-size: 25px;
    border-bottom: 1px #646464 dashed;
    padding: 10px 0px;
}
h1 a {
    color: #ff8600;
}

.panal{
  background:#fff;
  border-radius:10px;
color:#fff;
padding:0px 0px 20px 0px;
margin:10px 0;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;

}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body{
    padding:20px;
    color:#333;
}

.app-stu-photo {
  float: right;

  border-radius: 10px;
  border: 1px solid #111;
 
}

  .app-stu-photo img {
    width: 100%;
    border-radius: 10px;

  }

  .app-All {
    width: 75%;
    float: left;
  }

  .app-stu {
    border-bottom: 1px #333 dotted;
    padding: 10px 0px;
   
    float: left;

  }

  .app-stu .title {
    font-weight: bold;

  }

  .app-stu .title span {
    font-weight: 100;



  }

  .table .thead-dark th {
    color: #fff;
    background-color: #dee2e6 !important;
    border-color: #989899 !important;
    font-size: 13px !important;
  }
.table .thead-light th {
    color: #495057;
    background-color: #e9ecef;
    border-color: #dee2e6;
    font-size: 13px !important;
}

.bg-filter{
   background: #cacaca;
    padding: 10px;
    width:100%;
}

.profileData, .profileData2 {
    border: 1px dotted #646464;
    padding: 3px 10px;
    font-weight: 700;
    margin: 5px 0px;
}
.profileData {
    color: #285475;
}
.profileData2 {
    color: #ff8600;
}

@media only screen and (max-width: 600px) {
  .panal-header{
       width: 90% !important;
  }
  .app-stu-photo {
  float: none;

 
 
}
}

</style>
